import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule, inject } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideHighcharts } from 'highcharts-angular';

import { environment } from '../environments/environment';
import { AuxiliaresModule } from './auxiliares/auxiliares.module';
import { PwaService } from './auxiliares/servicios/pwa.service';

// Locale
import { MatPaginatorIntl } from '@angular/material/paginator';
import { getEspPaginatorIntl } from 'src/locale/paginator-intl';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';
registerLocaleData(localeEs, 'es-AR');
//

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    //
    AuxiliaresModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    provideAnimationsAsync(),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MatPaginatorIntl, useValue: getEspPaginatorIntl() },
    provideHighcharts({
      instance: () =>
        import('highcharts/esm/highcharts').then((m) => m.default),
      modules: () => [
        import('highcharts/esm/modules/stock'),
        import('highcharts/esm/modules/no-data-to-display'),
        import('highcharts/esm/highcharts-more'),
        import('highcharts/esm/modules/boost'),
        import('highcharts/esm/modules/solid-gauge'),
        import('highcharts/esm/indicators/indicators'),
        import('highcharts/esm/indicators/regressions'),
        import('highcharts/esm/modules/xrange'),
        import('highcharts/esm/highcharts-3d'),
        import('highcharts/esm/themes/sunset'),
      ],
      options: {
        time: {
          timezone: 'America/Argentina/Buenos_Aires',
        },
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  pwa = inject(PwaService);
}
